import {
  IconButton,
  Tooltip,
  useMediaQuery,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  Link,
} from "@mui/material";
import { IoInformationCircleOutline, IoClose } from "react-icons/io5";
import JGIcon from "../JGIcon";
import { useState, useEffect } from "react";
import { useAppContext } from "Context";
import { isPremium } from "Utils/Account/Plan";
import { useAuth0 } from "react-auth0-spa";

interface SongInfoButtonProps {}

const SongInfoButton = (props: SongInfoButtonProps) => {
  const { breakpoints } = useTheme();
  const { songRawData } = useAppContext();
  const { isAuthenticated, user } = useAuth0();
  const isDesktop = useMediaQuery(breakpoints.up("lg"));

  const [open, setOpen] = useState(false);
  const [discogsDataUrl, setDiscogsDataUrl] = useState<any>();
  const [discogsData, setDiscogsData] = useState<any>();
  const [footer, setFooter] = useState<any>();

  useEffect(() => {
    var validInstruments = [
    "piano",
    "vibraphone",
    "electric piano",
    "acoustic piano",
    "synthesizer",
    "organ",
    "guitar",
    "acoustic-guitar",
    "electric-guitar",
    "bass",
    "bass-guitar",
    "ukulele",
    "saxophone",
    "soprano-saxophone",
    "alto-saxophone",
    "tenor-saxophone",
    "baritone-saxophone",
    "conductor",
    "trumpet",
    "flugelhorn",
    "french-horn",
    "cornet",
    "trombone",
    "tuba",
    "drums",
    "congas",
    "conga",
    "bongo",
    "percussion",
    "vocalist",
    "vocal",
    "singer",
    "orchestra",
    "symphony",
    "flute",
  ];
    var discogsDataHtml = "";
    var notes = "";
    var instrumentCount = 0;
    var ignoreInstrumentCount = false;
    var isDiscogs = false;
    if (songRawData?.tags) {
      for (let tag in songRawData.tags) {
        if (
          tag === "jg-voiceover" &&
          (songRawData.tags[tag] === "FD" || songRawData.tags[tag] === "DJ")
        ) {
          break;
        }
        if (
          tag.startsWith("metadata") &&
          tag !== "metadata-source" &&
          tag !== "metadata-source-url" &&
          tag !== "metadata-notes" &&
          tag !== "metadata-number-of-instruments-ok"
        ) {
          var instrument =
            tag.indexOf("metadata-track") > -1
              ? tag.substring("metadata-track-".length)
              : tag.indexOf("metadata-album") > -1
              ? tag.substring("metadata-album-".length)
              : "";
          if (validInstruments.includes(instrument)) {
            instrumentCount++;
          } else {
            for (var i = 0 ; i < validInstruments.length;i++) {
              if (instrument.indexOf(validInstruments[i]) > -1) {
                instrumentCount++;
                break;
              }
             }
          }
          
          let metadataKeyName = capitalizeFirstLetter(
            tag
              .replace(/-/g, " ")
              .replace("metadata ", "")
              .replace("track ", "")
              .replace("album ", "")
          );
          discogsDataHtml =
            discogsDataHtml +
            "<b>" +
            metadataKeyName +
            ":</b> " +
            encodeHTML(songRawData.tags[tag]) +
            "<br /><hr />";
        }

        if (tag === "metadata-source-url") {
          setDiscogsDataUrl(songRawData.tags[tag]);
        }
        if (tag === "metadata-source" && songRawData.tags[tag].toLowerCase() === "discogs") {
          isDiscogs = true;
        }
        if (tag === "metadata-notes") {
          notes = songRawData.tags[tag];
        }
        if (tag === "metadata-number-of-instruments-ok") {
          ignoreInstrumentCount = true;
        }
      }
      if (notes !== "") {
        discogsDataHtml =
          discogsDataHtml +
          "<b>Album Notes:</b> " +
          encodeHTML(notes) +
          "<br /><hr />";
      }
    }
    if (!isDiscogs) {
      setDiscogsDataUrl(null);
    }
    if (discogsDataHtml !== "" && (ignoreInstrumentCount || instrumentCount > 2))
      setDiscogsData(discogsDataHtml);
    else
      setDiscogsData(null);
  }, [songRawData]);

  function capitalizeFirstLetter(val) {
    var newVal = "";
    var words = val.split(" ");
    for (var i = 0; i < words.length; i++) {
      newVal =
        newVal +
        String(words[i]).charAt(0).toUpperCase() +
        String(words[i]).slice(1) +
        " ";
    }
    return newVal.substring(0, newVal.length - 1);
  }

  function encodeHTML(s) {
    if (typeof s === "string")
     return s
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/"/g, "&quot;");
    else
      return s;
  }

  function formMailTo() {
    return (
      "mailto:help@jazzgroove.org?subject=" +
      encodeURIComponent("Enriched metadata question") +
      "&body=" +
      encodeURIComponent(
        "Hi Jazz Groove, The enriched metadata displayed for " +
          songRawData?.tags?.TITLE +
          " by " +
          songRawData?.tags?.ARTIST +
          " that was retrieved from " +
          discogsDataUrl +
          " doesn't seem to be accurate. Thanks for looking into it!"
      )
    );
  }

  const openInfo = async () => {
    if (discogsDataUrl != null)
      setFooter(" ");
    if (!isAuthenticated || !isPremium(user.plan)) {
      let infos: any = localStorage.getItem("infos");
      let date;
      if (!infos) {
        date = new Date();
        date.setHours(date.getHours() + 24, 0, 0, 0);
        infos = {
          count: 0,
          resetTime: date.getTime(),
        };
        infos.count = 1;
      } else {
        infos = JSON.parse(infos);
        if (infos.count === 3 && infos.resetTime > new Date().getTime()) {
          setDiscogsData(
            "We're 100% listener-funded. Therefore listeners who contribute receive UNLIMITED \"Who Played What\" info cards. Do your part and unlock UNLIMITED!<br />Already a donor? <a href=\"https://auth.jazzgroove.org/u/login?state=hKFo2SByQ1J4ck4wZkVaY25XSVl6aVczN0xqOGVPZ2N4WDAtdaFur3VuaXZlcnNhbC1sb2dpbqN0aWTZIHpoTmJ0Tmtqd1hWTnNDYWZEM18tZ3d4MXhONnF6Q2JHo2NpZNkgYkp1NWJuNmJhanlBcENkUmZvaFlINzJDWWN5V1dNOHg\">SIGN IN</a><br />Otherwise, <a href=\"https://www.jazzgroove.org/checkout\">DONATE</a>."
          );
          setFooter(null);
        } else {
          if (infos.resetTime < new Date().getTime()) {
            date = new Date();
            date.setHours(date.getHours() + 24, 0, 0, 0);
            infos.resetTime = date.getTime();
            infos.count = 1;
          } else {
            infos.count = infos.count + 1;
          }
        }
      }
      localStorage.setItem("infos", JSON.stringify(infos));
    }
    setOpen(true);
  };

  return (
    <>
      <Tooltip title="Song Info">
        {discogsData && (
          <IconButton aria-label="Song Info" onClick={openInfo}>
            <JGIcon
              is={IoInformationCircleOutline}
              fontSize={isDesktop ? "medium" : "small"}
            />
          </IconButton>
        )}
      </Tooltip>
      <Dialog
        onClose={() => setOpen(false)}
        aria-labelledby="song-info-title"
        open={open}
        maxWidth="lg"
      >
        <DialogTitle id="song-info-title">
          <>Song information</>
          <IconButton
            aria-label="close"
            color="default"
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <IoClose />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {discogsData && (
            <div style={{ textAlign: "left" }}>
              <div dangerouslySetInnerHTML={{ __html: discogsData }}></div>
            </div>
          )}
          {footer && (
            <div style={{ textAlign: "left" }}>
              <div style={{ marginTop: "20px", textAlign: "center" }}>
                <a href={discogsDataUrl} target="_blank" rel="noreferrer">
                  Data
                </a>{" "}
                provided by Discogs.
              </div>
              <div style={{ marginTop: "20px" }}>
                If you believe this data is inaccurate,{" "}
                <Link target="_blank" href={formMailTo()}>
                  let us know
                </Link>{" "}
                and we will investigate. <br />
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SongInfoButton;
